const getUrl = (type) => {
  switch(type) {
    case "daily":
      return "report/daily";
    case "month":
      return "report/monthly";
    case "session":
      return "/report/session";
    case "features":
      return "/report/features";
    default:
      return "report";
  }
}

const reportsApi = ({ apiClient }) => ({
  summary(params, type = null, headers = {}) {
    const url = getUrl(type);

    return apiClient.get(url, {}, params, headers)
  },
  featuresBySession(sessionId) {
    return apiClient.get(`/report/features/${sessionId}`, {}, {})
  },
})

export default reportsApi
